<template>
  <m-single-lesson-wrapper :course-link="courseLink" :lesson-link="lessonLink">
    <template v-slot="{lesson,access,courseSlug,lessonSlug}">

      <b-col>
        <b-card class="mx-auto">
          <b-row class="d-flex flex-row justify-lesson-between p-5">

            <b-col>
              <h4>{{ lesson.title }}</h4>
            </b-col>

            <b-col class="text-left">
              <router-link :to="{name: 'SingleCourse', params:{slug: courseSlug}}">
                <b-button id="to-course" pill>بازگشت به دوره</b-button>
              </router-link>
            </b-col>

          </b-row>
          <hr class="mx-auto">
          <div class="card-body p-4">
            <img id="lesson-img" :src="lesson.thumbnail" :alt="lesson.title"/>
            <h4 class="mt-5">درباره دوره</h4>
            <p v-html="lesson.abstraction"/>
            <h4 class="mt-5">توضیحات</h4>
            <div class="text-center col-lg-12">
              <h4 v-if="!access" class="text-center rounded-pill p-1 access-to-course">
                برای استفاده از دوره لطفا یکی از


                <router-link class="text-dark text-decoration-none course-product-link"
                             :to="{name:'SingleCourse',params:{slug:courseSlug}}">
                  محصولات دوره
                </router-link>
                را خریداری کنید.
              </h4>
            </div>
            <p class="card-text" v-html="processContent(lesson.body)"/>
          </div>
        </b-card>
      </b-col>

    </template>
  </m-single-lesson-wrapper>
</template>

<script>
export default {
  name: "SingleLesson1",
  props: {
    courseLink: {
      default: null
    },
    lessonLink: {
      default: null
    },
  }
}
</script>

<style scoped>

.card {
  background-color: #fff;
  max-width: 1000px;
}

.card-body {
  padding: 7px;
}

.card-title {
  margin-right: 50px;
  margin-top: 30px;
}

hr {
  background-color: #707070;
  color: #707070;
  width: 90%;
  display: flex;
  align-self: center;

}

.card-text {
  margin-top: 50px;
  text-align: right;
}

span {
  font-size: 12px;
}

p {
  font-size: 14px;
}

#post-img, #page-img, #lesson-img {
  width: 100%;
  border-radius: 4px;
  object-fit: cover;
  height: 550px;
}

#to-course {
  background-color: var(--primary);
  color: white;
}

.access-to-course {
  background-color: var(--primary);
  color: white;
}

.video-wrapper {
  display: none !important;
}

.course-product-link {
  color: var(--secondary) !important;
}

</style>